import styled from "styled-components";
import { IndicatorLayout } from "../consts/indicator-layout";

export const IndicatorDefaultBox = styled.div<{displayLayout?: IndicatorLayout}>`
    display: flex;
    flex-direction: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "row" : "column" };
    align-items: center;
    flex-grow: ${({displayLayout}) => displayLayout === IndicatorLayout.FullWidth ? 1 : 0 };

    position: relative;
    width: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "auto" : "calc((100% - 1rem) / 2)" };
    padding: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "1rem 0" : "0.5rem 0" };
    margin: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "0 1rem" : "0" };
    background: ${({theme, displayLayout}) => displayLayout === IndicatorLayout.List ? "none" : theme.colors.backgroundLight};
    border-top: ${({displayLayout, theme}) => displayLayout === IndicatorLayout.List ? ("1px solid " + theme.colors.boxBorder) : "none" };
    border-radius: 5px;
    cursor: pointer;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 0.5rem 0;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: 1rem 0;
        background: ${({theme}) => theme.colors.background}; // componentBackground usefulLinkBackground userMenuSectionBg
    }
`;
